import { useState, useEffect, useRef } from 'react'

import { AxiosResponse } from 'axios'
import { Card } from 'components'
import {
  useAuth,
  useLoading,
  useModal,
  usePersistForm,
  useToggle
  //handleNulluseCheckListWithPagination
} from 'hooks'
import useApp from 'hooks/useApp'
import moment from 'moment'
import {
  RequestSetDisponibilidade,
  AddAnalyzeCREServices,
  ResponseAnaliseCREInicial
} from 'services/NGT/AnalyzeCRE'
import {
  WalletNGTServices,
  WalletItemServices,
  IWalletYearMonthCompetenceRequest,
  IManageWalletTable,
  IWalletYearMonthCompetenceResponse,
  IResponseGetStatusOcupado,
  IGetStatusOcupadoItems
} from 'services/NGT/Wallet'
import { SPACING } from 'utils'

import { ViewContractModal } from '../ViewContractModal/ViewContractModal'
import { ManageCreFilter, TableManageCre } from './components'
import { useForm } from 'react-hook-form'
import { hasConnectionLostError } from 'services/Instances/utils'

export interface IWalletInfoCre {
  PrimeiraMob: boolean
  UltMed: boolean
  Denuncia: boolean
  Projeto: boolean
  Alerta: boolean
}
export interface ManageCreFilterProps {
  analistas: string
  matriculaAnalista
  walletInfoCre: {
    Alerta: boolean
    Denuncia: boolean
    PrimeiraMob: boolean
    Projeto: boolean
    UltMed: boolean
  }
  filterSearch: string
}

const GenerateCre: React.FC = () => {
  const { showModal, closeModal, showConnectionLostModal } = useModal()
  //const [, setWalletSearchResult] = useState<IWalletYearMonthCompetenceRequest>()
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const { setTitlePage } = useApp()
  const [totalItems, setTotalItems] = useState<number>(0)
  const dateNow = new Date()
  const { setLoading } = useLoading()
  const [responseTableData, setResponseTableData] = useState<
    IManageWalletTable[]
  >([])
  const [tableData, setTableData] = useState<IManageWalletTable[]>([])

  const { control, watch, setValue, reset } = useForm<ManageCreFilterProps>({
    defaultValues: {
      analistas: '',
      matriculaAnalista: '',
      walletInfoCre: {
        Alerta: false,
        Denuncia: false,
        PrimeiraMob: false,
        Projeto: false,
        UltMed: false
      },
      filterSearch: ''
    }
  })

  const walletInfoCre = watch('walletInfoCre')
  const filterSearch = watch('filterSearch')

  usePersistForm('ngt_manage_cre_filter', {
    setValue,
    watch
  })

  const [idItens, setIdItens] = useState<number[]>([])
  const [stopPing, setStopPing] = useState<boolean>(false)
  const [checkAll, setCheckAll] = useState(false)
  const [unCheckAll, setUncheckAll] = useState(false)
  const [itensCheckados, setItensCheckados] = useState<number[]>([])
  const [paginacao, setPaginacao] = useState<boolean>(false)
  const [idAnalista, setIdAnalista] = useState<number>()
  const [selectedContractId, setSelectedContractId] = useState<number>(0)
  const [openViewContractModal, toggleViewContractModal] = useToggle()
  const { user } = useAuth()
  const [cre, setCre] = useState<ResponseAnaliseCREInicial>()
  const idCre = useRef<number>()
  const saveCre = useRef<boolean>(false)
  const [iniciarPing, setIniciarPing] = useState<boolean>(false)
  const [novaAnalise, setNovaAnalise] = useState<boolean>(true)
  const [fazerPing, setFazerPing] = useState<number>(0)
  const [disponibilidadeCre, setDisponibilidadeCre] = useState<
    IGetStatusOcupadoItems[]
  >([])
  const [connLost, setConnLost] = useState<boolean>(false)
  let isWalletSearching = false

  const handleViewContractModal = (contractId: number) => {
    setSelectedContractId(contractId)
    toggleViewContractModal()
  }

  const checkTodos = (): boolean => {
    return (
      !walletInfoCre.Alerta &&
      !walletInfoCre.Denuncia &&
      !walletInfoCre.Projeto &&
      !walletInfoCre.UltMed &&
      !walletInfoCre.PrimeiraMob
    )
  }

  const handleNull = () => {
    showModal({
      hideButtonCancel: true,
      message:
        'Nenhum registro encontrado para a Carteira da competência atual.',
      txtButtonConfirm: 'FECHAR',
      type: 'alert'
    })
  }

  const handleSearchWallet = async () => {
    if (isWalletSearching) return
    isWalletSearching = true

    setLoading('loading')
    const obj: IWalletYearMonthCompetenceRequest = checkTodos()
      ? {
        Alerta: null,
        CheckAll: checkAll,
        DataAtual: dateNow.toISOString(),
        Denuncia: null,
        PageNumber: page,
        PageSize: rowsPerPage,
        Paginacao: paginacao,
        PrimeiraMob: null,
        Projeto: null,
        SearchQuery: watch('filterSearch'),
        Todos: true,
        UltMed: null
      }
      : {
        ...watch('walletInfoCre'),
        CheckAll: checkAll,
        PageNumber: page,
        PageSize: rowsPerPage,
        Paginacao: paginacao,
        SearchQuery: watch('filterSearch'),
        Todos: false
      }

    try {
      const response: AxiosResponse<IWalletYearMonthCompetenceResponse> =
        await WalletNGTServices().GetCarteirasAnoMesCompetencia(obj)
      if (response.status === 200) {
        if (response.data.entity === null) {
          handleNull()
          setTableData([])
        } else {
          setTotalItems(response.data.entity.gridItens.pageCount)
          setTableData(response.data.entity.gridItens.items)
          setResponseTableData(response.data.entity.gridItens.items)
          setDisponibilidadeCre([])
          if (!paginacao && checkAll) {
            setItensCheckados(response.data.entity.cresIds)
          }
        }
        setLoading('idle')
      }
    } catch (error) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message:
          'Não foi possível obter os resultados da pesquisa. Tente novamente em instantes...',
        txtButtonConfirm: 'OK',
        type: 'error'
      })
    } finally {
      isWalletSearching = false
    }
  }

  const removeTitle = () => setTitlePage(null)

  useEffect(() => {
    setTitlePage(
      `CARTEIRA - ${moment().subtract(1, 'months').format('MM/yyyy')}`
    )

    window.addEventListener('onbeforeunload', removeTitle)

    return () => {
      removeTitle()
      window.removeEventListener('onbeforeunload', removeTitle)
    }
  }, [])

  const handlePingReport = async () => {
    let pingErrors = 0
    if (iniciarPing) {
      try {
        const obj: RequestSetDisponibilidade = {
          creId: idCre.current
        }
        const pingResponse = await AddAnalyzeCREServices().manterCreOcupado(obj)
        if (pingResponse.status !== 200) {
          throw new Error('Não foi possível atualizar este CRE no momento')
        }
      } catch (errors: any) {
        pingErrors += 1
        if (pingErrors === 3) {
          showModal({
            hideButtonCancel: true,
            message: 'A atualização no monitoramento deste CRE falhou.',
            txtButtonConfirm: 'Fechar',
            type: 'alert'
          })
        } else {
          return
        }
      }
    }
  }

  const VerificarDisponibilidadeCRE = async () => {
    const idCreList: number[] = tableData?.map(
      (item: IManageWalletTable) => item.creId
    )
    if (stopPing && !hasConnectionLostError()) setStopPing(false)

    setTimeout(() => {
      setFazerPing(fazerPing + 1)
    }, 6000)

    if (idCreList.length > 0 && !stopPing) {
      try {
        const response: AxiosResponse<IResponseGetStatusOcupado> =
          await WalletItemServices().verificarDisponibilidadeCre(idCreList)

        if (response.data.sucesso) {
          setDisponibilidadeCre(response.data.entity)
          if (connLost) {
            showModal({
              hideButtonCancel: true,
              message: 'Conexão do servidor reestabelecida',
              titleModal: 'OK',
              txtButtonConfirm: 'Fechar',
              type: 'success'
            })
            setConnLost(false)
          }
        } else {
          throw new Error(
            response.data.mensagem ||
            'Ocorreu um erro ao verificar disponibilidade dos Contratos'
          )
        }
      } catch (error: any) {
        if (connLost) return
        if (hasConnectionLostError()) {
          setStopPing(true)
          showConnectionLostModal()
          return
        }
        if (error?.status == 400) setConnLost(true)
        showModal({
          hideButtonCancel: true,
          message:
            error.message ||
            error.messagem ||
            'Ocorreu um erro ao verificar disponibilidade do CRE',
          titleModal: 'Alerta',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })
      }
    }
  }

  useEffect(() => {
    VerificarDisponibilidadeCRE()
  }, [fazerPing])

  useEffect(() => {
    if (disponibilidadeCre.length == tableData.length) {
      const newTableData: IManageWalletTable[] = tableData.map(
        (item: IManageWalletTable, index: number) => {
          if (
            item.creId === disponibilidadeCre[index].idCre &&
            item.creDisponivel != !disponibilidadeCre[index].creOcupado
          ) {
            return {
              ...item,
              codCre: disponibilidadeCre[index].codigoCRE,
              creDisponivel: !disponibilidadeCre[index].creOcupado,
              dtAnalise: disponibilidadeCre[index].dataAnalise,
              nmAnalista: disponibilidadeCre[index].nomeAnalista,
              txStatusColor: disponibilidadeCre[index].status
            }
          } else {
            return item
          }
        }
      )
      setTableData(newTableData)
    }
  }, [disponibilidadeCre])

  useEffect(() => {
    const interval = setInterval(handlePingReport, 5000)
    return () => clearInterval(interval)
  }, [iniciarPing])

  const handleContractSelection = (contract: number, index: number) => {
    if (tableData[index].checked) {
      tableData[index].checked = false
      setItensCheckados(
        [
          ...itensCheckados.filter((include: number) => include !== contract)
        ].filter((i: number) => i)
      )
    } else {
      tableData[index].checked = true
      setItensCheckados((cre: number[]) =>
        [...cre, tableData[index].creId].filter((i: number) => i)
      )
    }
    setTableData([...tableData])
  }

  const handleDesignate = () => {
    /*  20/07/2022
    const selectedItems = itensCheckados.map(
      (item: IManageWalletTable) => item.creId
    )
    if (idAnalista && selectedItems && selectedItems?.length > 0) {
      const obj = { cresIds: selectedItems, usuarioId: idAnalista }
    */

    if (idAnalista && itensCheckados && itensCheckados.length > 0) {
      const designateRequest: { cresIds: number[]; usuarioId: number } = {
        cresIds: itensCheckados,
        usuarioId: idAnalista
      }

      WalletItemServices()
        .designateAnalyst(designateRequest)
        .then(() => {
          showModal({
            hideButtonCancel: true,
            message: 'Analista designado com sucesso',
            txtButtonConfirm: 'FECHAR',
            type: 'success'
          })
          setItensCheckados([])
          setUncheckAll(true)
          setCheckAll(false)
          setIdItens([])
          setTableData([])
          setPage(1)
          handleSearchWallet()
        })
        .catch(() => {
          showModal({
            hideButtonCancel: true,
            message: 'Não foi possível designar o anallista',
            txtButtonConfirm: 'FECHAR',
            type: 'error'
          })
        })
    } else {
      showModal({
        hideButtonCancel: true,
        message: 'Selecione pelo menos um item e um analista',
        txtButtonConfirm: 'FECHAR',
        type: 'error'
      })
    }
  }

  const handleFilterTableData = () => {
    if (page === 1) {
      handleSearchWallet()
      return
    }
    setPage(1)
  }

  /////////  Lógica checkbox Todos
  useEffect(() => {
    if (unCheckAll) {
      tableData.forEach((item) => {
        item.checked = false
      })
      setUncheckAll(false)
    } else {
      tableData.forEach((item) => {
        if (item.creId) {
          if (itensCheckados.includes(item.creId)) {
            item.checked = true
          } else {
            item.checked = false
          }
        }
      })
    }
  }, [tableData, itensCheckados])

  useEffect(() => {
    setItensCheckados([])
    setUncheckAll(true)
    setCheckAll(false)
    setIdItens([])
    setTableData([])
    setTimeout(() => {
      setPage(1)
    }, 400)
  }, [walletInfoCre])

  useEffect(() => {
    if (itensCheckados?.length > 0) {
      setPaginacao(true)
    } else {
      setPaginacao(false)
    }
    handleSearchWallet()
  }, [rowsPerPage, page, checkAll])

  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
        borderRadius={`0px 10px 0px 0px`}
      >
        <ManageCreFilter
          handleFilterTableData={handleFilterTableData}
          handleDesignate={handleDesignate}
          setIdAnalista={setIdAnalista}
          checkTodos={checkTodos}
          watch={watch}
          reset={reset}
          setValue={setValue}
        />
        <TableManageCre
          idItens={idItens}
          handleContractSelection={handleContractSelection}
          setIdItens={setIdItens}
          handleNull={handleNull}
          checkPages={checkAll}
          setCheckPages={setCheckAll}
          setCheckAll={setCheckAll}
          checkAll={checkAll}
          tableData={tableData}
          totalItems={totalItems}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          selectedContractInfo={handleViewContractModal}
        /*  20/07/2022
      handleSelectItem={handleSelectItem}
      handleToWaive={handleToWaive}
      handleCheckAll={handleCheckAll}
      isAllChecked={isAllChecked}*/
        />
      </Card>
      <ViewContractModal
        showModal={openViewContractModal}
        toggleModal={toggleViewContractModal}
        contractID={selectedContractId}
      />
    </>
  )
}

export default GenerateCre
